import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// build/index.html ships prerendered markup (scripts/prerender.mjs); dev does not.
const container = document.getElementById('root') as HTMLElement;
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
